export default {
  region: import.meta.env.VITE_AWS_REGION || "us-west-2",
  userPoolId: import.meta.env.VITE_AWS_USERPOOL_ID || "us-west-2_kn09jU59q",
  userPoolWebClientId:
    import.meta.env.VITE_AWS_USERPOOL_WEBCLIENT_ID ||
    "57oivsqmnba05hptal6msk06lq",
};
